// js
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classnames from 'classnames';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as actionCreators from '../actions/dsaActions';
import { beginCloneDSAWorkflow, beginConvertCustomerDSAWorkflow, confirmBeginConvertCustomerDSAWorkflow } from '../actions/createDSAWorkflowActions';
import { setSplunkLearningLink } from '../actions/stringActions';
import { fetchOpportunities } from '../actions/opportunityActions';
import AccountInformation from '../components/AccountInformation';
import DSATabs from '../components/DSATabs';
import CreateDSAWorkflow from './account/CreateDSAWorkflow';
import * as dsaTypes from '../constants/dsaTypes';
import { isPartnerUser, isInternalUser, getAssessmentTitle } from '../utils/assessmentUtils';
import ConvertTrainingSnackbar from '../components/common/ConvertTrainingSnackbar';
import RouteUser from '../components/RouteUser';
import { CommonUIUtils, LoadingScreen, SubnavHeader, UserSurvey } from '@its-svp/svp-common-ui';
import { shuffle } from '../utils/shuffle';
import DSANote from '../components/common/DSANote';
// pptx
import buildPPTXSlideDefinitions from './pptx/buildPPTXSlideDefinitions';
import StaticMarkup from './pptx/StaticMarkup';
import * as FileSaver from 'file-saver';
// selectors
import { makeGetActiveAreas, makeGetAllAreas } from '../selectors/dsa/areaSelectors';
import { getVisibleAccount } from '../selectors/account/accountSelectors';
import { getAbilities } from '../selectors/dsa/abilitiesSelectors';
import { makeGetTotalSourcesStats } from '../selectors/analytics/overviewSelectors';
import { getAcceptableCriticalSecurityCorrelationsCount, getCriticalSecurityCorrelationsCount, getSecurityDashboardsByCategoryInCategoriesWithMultipleSubcategories } from '../selectors/analytics/securitySelectors';
import { getCompletedActiveConfiguredItems, getCompletedActiveConfiguredItemsCount } from '../selectors/dsa/sourcesSelectors';
import { getCorrelationsWithAnswersAndCategoryTitles } from '../selectors/dsa/correlationSelectors';
import { makeGetAreaOverlap, makeGetNewCustomerOverlap } from '../selectors/analytics/overlapSelectors';
import { makeGetCombinedTabularRecommendations } from '../selectors/analytics/recommendationSelectors';
import { getChartFormattedValueRealizedByArea } from '../selectors/analytics/valueRealizedSelectors';
import { getKeyGoalsCount } from '../selectors/analytics/goalsSelector';
import { getDSAPeakBuffer } from '../selectors/dsaSelectors';
import { trackEvent } from '../utils/analytics';
// css for header
import '../styles/components/AssessmentHeader.scss';

const defaultPropTypes = {
  // abilities matrix for this DSA
  abilities: PropTypes.object,
  // route
  params: PropTypes.object,
  // misc strings
  strings: PropTypes.object,
  // logged in user
  user: PropTypes.object,
  // current dsa
  dsa: PropTypes.object,
  // current area (selected tab)
  area: PropTypes.object,
  // dsa config...
  areas: PropTypes.array,
  extensions: PropTypes.array,
  configExtensions: PropTypes.array,
  subAreas: PropTypes.array,
  useQuestions: PropTypes.array,
  configuredItems: PropTypes.array,
  goals: PropTypes.array,
  userGroups: PropTypes.array,
  analysisGoals: PropTypes.array,
  analysisUserGroups: PropTypes.array,
  configuredItemUserGroups: PropTypes.array,
  valueRealized: PropTypes.array,
  overlapStats: PropTypes.object,
  areaTotalStats: PropTypes.object,
  loading: PropTypes.bool,
  configLoading: PropTypes.bool,
  configError: PropTypes.bool,
  // actions...
  fetchDSA: PropTypes.func,
  fetchDSAConfig: PropTypes.func,
  setSplunkLearningLink: PropTypes.func,
  savingUpdatesText: PropTypes.string
};


// HOC for Assessment views
function dsaView(WrappedComponent, options = {}) {

  class DSAView extends Component {
    constructor(props) {
      super(props);
      this.state = {
        displayUserSurveyModal: false
      };
      this.beginCloneDSAWorkflow = this.beginCloneDSAWorkflow.bind(this);
      this.confirmBeginConvertCustomerDSAWorkflow = this.confirmBeginConvertCustomerDSAWorkflow.bind(this);
      this.beginConvertCustomerDSAWorkflow = this.beginConvertCustomerDSAWorkflow.bind(this);
      this.generatePPTXAndDownload = this.generatePPTXAndDownload.bind(this);
      this.showUserSurveyModal = this.showUserSurveyModal.bind(this);
      this.closeUserSurveyModal = this.closeUserSurveyModal.bind(this);
    }

    async componentDidMount() {
      await this.reload();
      // Only need to fetch opportunities once when the assessment first loads.
      // Wait until account info has been fetched to fetch opportunities.
      if (!this.props.opportunities.data && this.props.dsa.account) {
        this.props.fetchOpportunities(this.props.dsa.account.sfid);
      }
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.params.slug !== this.props.params.slug) {
        this.props.fetchDSA(nextProps.params.slug);
        this.props.fetchDSAConfig(nextProps.params.slug);
      }
      // Unused - pre-Account Details
      if (this.props.loading && nextProps.loading === false && nextProps.dsa) {
        if (nextProps.dsa.dsa.dsaType === dsaTypes.NEW_CUSTOMER_DSA) {
          this.props.setSplunkLearningLink(nextProps.dsa.dsa.type);
        }
      }
    }

    async reload() {
      try {
        await this.props.fetchDSA(this.props.params.slug);
        this.props.setSplunkLearningLink(this.props.dsa.dsa.type);
        this.props.fetchDSAConfig(this.props.params.slug);
      } catch (err) {
        this.props.dsa.error = err;
      }
    }

    getClassNames() {
      return [options.className, 'dsa-list-itemview'].join(' ');
    }

    beginConvertCustomerDSAWorkflow() {
      this.props.beginConvertCustomerDSAWorkflow(this.props.dsa.dsa);
    }

    beginCloneDSAWorkflow() {
      this.props.beginCloneDSAWorkflow(this.props.dsa.dsa);
    }

    confirmBeginConvertCustomerDSAWorkflow() {
      this.props.confirmBeginConvertCustomerDSAWorkflow(this.props.dsa.dsa);
    }

    renderContent(baseNavRoute) {
      const {
        strings,
        reloadingDsa
      } = this.props;

      if (reloadingDsa) {
        return (
          <div className='svp-common-ui'>
            <LoadingScreen title={strings.loadingText} />
          </div>
        );
      } else {
        return (
          <section>
            <WrappedComponent {...this.props} baseNavRoute={baseNavRoute} />
          </section>
        );
      }
    }

    getSidebarColors(assessmentType) {
      return classnames({
        'full': assessmentType === dsaTypes.FULL_DSA,
        'new-customer': assessmentType === dsaTypes.NEW_CUSTOMER_DSA
      });
    }

    renderSidebar() {
      const { dsa } = this.props;
      let assessmentTypeName = getAssessmentTitle(dsa.dsa.type);

      return (
        <div className={`sidebar ${dsa.dsa.state === 'closed' ? 'closed' : this.getSidebarColors(dsa.dsa.type)}`}>
          <div className='svp-white-bars-logo-bg'>
            <div className='assessment-type'>
              { dsa.dsa.state === 'closed' ? 'CLOSED' : assessmentTypeName }
            </div>
          </div>
        </div>
      );
    }

    showUserSurveyModal(value) {
      this.setState({
        displayUserSurveyModal: value
      });
    }

    closeUserSurveyModal() {
      this.setState({
        displayUserSurveyModal: false
      });
    }

    async generatePPTXAndDownload() {
      let staticComponents = buildPPTXSlideDefinitions({
        areas: this.props.activeAreas,
        dashboardCategories: this.props.navigableDashboardCategories
      });
      let { dsa, user } = this.props;
      const assessmentType = dsa && dsa.dsa && dsa.dsa.dsaType;
      const flow = isPartnerUser(user) ? 'partner' : 'internal';
      const pptxBase = { tool: 'dsa', assessment_type: assessmentType, flow };
      trackEvent('assessment_pptx_generate', Object.assign({ status: 'started' }, pptxBase));

      let baseNavRoute = `/account/${dsa.account.sfid}/dsa/${dsa.dsa.id}`;

      if (isPartnerUser(user)) {
        baseNavRoute = `/dsa/account/${dsa.account.sfid}/assessment/${dsa.dsa.id}`;
      }

      staticComponents.forEach((component) => {
        if (component.areaId !== null) this.props.params.areaId = component.areaId;
        if (component.dashboardCategoryId !== null) this.props.params.dashboardCategoryId = component.dashboardCategoryId;
        const componentProps = Object.assign({ baseNavRoute }, this.props, component.props || {});
        let markup = StaticMarkup.renderToString(component.Component, componentProps, component.name);
        component.markup = markup;
      });

      let summary = this.buildSummary();
      let sortedOverlapStats = this.buildOverlapStats(this.props.overlapStats, 'DESC');
      let sortedNewCustomerOverlapStats = this.buildOverlapStats(this.props.newCustomerOverlapStats, 'SHUFFLE');
      try {
        let pptxResponse = await this.props.generatePPTX(staticComponents, {
          dsa: this.props.dsa,
          abilities: this.props.abilities,
          activeAreas: this.props.activeAreas,
          configuredItems: this.props.recommendedConfiguredItems,
          securityCorrelations: this.props.securityCorrelations,
          dashboardCategories: this.props.navigableDashboardCategories,
          valueRealized: this.props.chartFormattedValueRealized,
          userGroups: this.props.userGroups,
          summary: summary,
          overlapStats: sortedOverlapStats,
          newCustomerOverlapStats: sortedNewCustomerOverlapStats,
          recommendations: this.props.recommendations,
          subAreas: this.props.subAreas
        });
        const fileName = CommonUIUtils.responseUtils.getFilenameFromContentDisposition(pptxResponse);
        if (fileName) {
          const fileType = pptxResponse.headers['content-type'];
          FileSaver.saveAs(new Blob([pptxResponse.data], { type: fileType }), fileName);
          this.showUserSurveyModal(true);
          trackEvent('assessment_pptx_generate', Object.assign({ status: 'success' }, pptxBase));
          trackEvent('assessment_pptx_download', Object.assign({ status: 'success' }, pptxBase));
        } else {
          // eslint-disable-next-line no-console
          console.warn('Error downloading PPTX', pptxResponse);
          trackEvent('assessment_pptx_generate', Object.assign({ status: 'error' }, pptxBase));
        }
      } catch (err) {
        trackEvent('assessment_pptx_generate', Object.assign({ status: 'error' }, pptxBase));
        throw err;
      }
    }

    buildSummary() {
      const {
        totalSourcesStats,
        recommendations,
        criticalSecurityCorrelationsCount,
        acceptableCriticalSecurityCorrelationsCount,
        keyGoalsCount,
        configuredItemsCount,
        peakBuffer
      } = this.props;

      let summary = {
        keyGoalsCount,
        configuredItemsCount,
        peakBuffer,
        criticalSecurityCorrelationsCount,
        acceptableCriticalSecurityCorrelationsCount,
        dataRequired: totalSourcesStats.dataRequired,
        environmentDataPerDay: totalSourcesStats.environmentDataPerDay,
        percentIndexed: totalSourcesStats.percentIndexed,
        moreData: recommendations.couldBeInUse.length,
        existingData: recommendations.shouldBeInUse.length
      };
      return summary;
    }

    buildOverlapStats(overlapStats, sortMethod) {
      let sortableStats = [];
      // merge all overlap status into a sortable array
      this.props.areas.forEach(area => {
        let areaId = area.id;
        for (let overlapAreaId in overlapStats[areaId]) {
          let stats = {
            area: area.title,
            overlapArea: this.props.areas.find(area => area.id === Number(overlapAreaId)).title,
            percentOverlap: overlapStats[areaId][overlapAreaId].overlapPercent * 100
          };
          sortableStats.push(stats);
        }
      });
      if (sortMethod === 'DESC') {
        sortableStats = sortableStats.sort((a, b) => b.percentOverlap - a.percentOverlap);
      } else if (sortMethod === 'SHUFFLE'){
        sortableStats = shuffle(sortableStats);
      }
      sortableStats = sortableStats.slice(0, 5);
      return sortableStats;
    }

    render() {
      const {
        dsa,
        areas,
        extensions,
        configExtensions,
        location,
        loading,
        strings,
        user,
        createDSAWorkflow,
        abilities,
        savingUpdatesText
      } = this.props;

      let loadingScreen = (
        <div className={`svp-common-ui ${this.getClassNames()}`}>
          <LoadingScreen
            title={strings.loadingText}
          />
        </div>
      );

      if (dsa.error) {
        return (
          <RouteUser status={dsa.data.status_code} />
        );
      }

      if (loading) {
        return loadingScreen;
      } else {
        let baseNavRoute = `/account/${dsa.account.sfid}/dsa/${dsa.dsa.id}`;
        if (isPartnerUser(user)) {
          baseNavRoute = `/dsa/account/${dsa.account.sfid}/assessment/${dsa.dsa.id}`;
        }

        // Show different subnav for COE (no navigation, only savingUpdatesText) vs DSA
        const subnavContent = { savingUpdatesText };

        if (isPartnerUser(user)) {
          let opportunityPath = '/opportunity';
          if (dsa.opportunities && dsa.opportunities.length > 0) {
            opportunityPath += `/${dsa.opportunities[0].sfid}/detail`;
          }
          subnavContent.breadcrumb = {
            navigation: {
              'Opportunity List': '/opportunity',
              'Opportunity Detail': opportunityPath
            },
            current: getAssessmentTitle(dsa.dsa.type)
          };
        } else if (isInternalUser(user)) {
          subnavContent.breadcrumb = {
            navigation: {
              'Account Selection': '/welcome',
              'Account Detail': `/account-details/${dsa.account.sfid}`
            },
            current: getAssessmentTitle(dsa.dsa.type)
          };
        }

        return (
          <div className={this.getClassNames()}>
            <div className='svp-common-ui'>
              <SubnavHeader subnavContent={subnavContent} />
              <UserSurvey
                open={this.state.displayUserSurveyModal}
                onClose={this.closeUserSurveyModal}
                assessment={dsa.dsa}
                user={user}
                accountSfid={dsa.account.sfid}
              />
            </div>
            <DSANote
              area={this.props.area}
              dsaArea={this.props.dsaArea}
            />
            <ConvertTrainingSnackbar
              assessment={dsa.dsa}
              dismiss={this.props.dismissTrainingSnackbar}
              maybeShow={dsa.trainingSnackBar.maybeShow}
              onConvertDSA={this.confirmBeginConvertCustomerDSAWorkflow}
            />
            <div className='assessment-header'>
              {this.renderSidebar()}
              <div className='assessment-header-content'>
                <div className='assessment-header-content-container'>
                  <AccountInformation
                    baseNavRoute={baseNavRoute}
                    onUpdateDSA={this.props.updateDSA}
                    onCloneDSA={this.beginCloneDSAWorkflow}
                    onConvertDSA={this.confirmBeginConvertCustomerDSAWorkflow}
                    generatePPTXAndDownload={this.generatePPTXAndDownload}
                    onConvertCustomerDSA={this.beginConvertCustomerDSAWorkflow}
                    dsa={dsa}
                    user={user}
                    pptx={this.props.pptx}
                  />
                  <DSATabs
                    baseNavRoute={baseNavRoute}
                    abilities={abilities}
                    pathname={location.pathname}
                    account={dsa.account}
                    dsa={dsa}
                    areas={areas}
                    user={user}
                    extensions={extensions}
                    configExtensions={configExtensions}
                  />
                </div>
              </div>
            </div>
            {this.renderContent(baseNavRoute)}
            <CreateDSAWorkflow
              account={dsa.account}
              user={user}
              open={createDSAWorkflow.open}
              generatePPTXAndDownload={this.generatePPTXAndDownload}
            />
          </div>
        );
      }
    }
  }

  DSAView.propTypes = {
    ...defaultPropTypes
  };

  // access to user, dsa, and text snippets (strings)
  const mapStateToProps = (state, ownProps) => {
    const dsa = state.dsa || {};
    const getActiveAreas = makeGetActiveAreas();
    const getAllAreas = makeGetAllAreas();
    const abilities = getAbilities(state);
    const activeAreas = getActiveAreas(state);
    const areas = getAllAreas(state);
    const dsaAreas = dsa.dsaAreas || [];
    const areaId = parseInt( ownProps.params.area, 10 );


    const getTotalSourcesStats = makeGetTotalSourcesStats();
    const recommendedConfiguredItems = getCompletedActiveConfiguredItems(state);
    const criticalSecurityCorrelationsCount = getCriticalSecurityCorrelationsCount(state);
    const acceptableCriticalSecurityCorrelationsCount = getAcceptableCriticalSecurityCorrelationsCount(state);
    const securityCorrelations = getCorrelationsWithAnswersAndCategoryTitles(state);
    const getNewCustomerOverlap = makeGetNewCustomerOverlap();
    const getAreaOverlap = makeGetAreaOverlap();
    const shouldBeInUseRecommendations = makeGetCombinedTabularRecommendations(1)(state);
    const couldBeInUseRecommendations = makeGetCombinedTabularRecommendations(0)(state);
    const chartFormattedValueRealized = getChartFormattedValueRealizedByArea(state);
    const keyGoalsCount = getKeyGoalsCount(state);
    const configuredItemsCount = getCompletedActiveConfiguredItemsCount(state);
    const peakBuffer = getDSAPeakBuffer(state);


    let area;
    if (areaId && areas && areas.find(a => a.id === areaId)) {
      area = areas.find(a => a.id === areaId) ;
    } else {
      area = null;
    }

    let dsaArea;
    if (areaId && dsaAreas && dsaAreas.find(a => a.area === areaId)) {
      dsaArea = dsaAreas.find(a => a.area === areaId);
    } else {
      dsaArea = null;
    }
    return {
      abilities,
      strings: state.strings,
      user: state.user,
      dsa: state.dsa,
      pptx: state.pptx,
      stats: state.stats,
      // dsa config sub-components
      ...state.dsaConfig,
      areas,
      // selected area (from route)
      area,
      dsaArea,
      activeAreas: getActiveAreas(state),
      activeAreaIds: activeAreas.map(a => a.area),
      extensions: state.dsa.dsaExtensions,
      configExtensions: state.dsaConfig.extensions,
      createDSAWorkflow: state.createDSAWorkflow,
      account: getVisibleAccount(state),
      navigableDashboardCategories: getSecurityDashboardsByCategoryInCategoriesWithMultipleSubcategories(state),
      loading: (!state.dsa.dsa || !state.dsaConfig.areas) || state.opportunities.loading,
      reloadingDsa: state.dsa.loading,
      configLoading: state.dsaConfig.loading,
      configError: state.dsaConfig.error,
      savingUpdatesText: state.savingUpdatesText,
      opportunities: state.opportunities,

      totalSourcesStats: getTotalSourcesStats(state),
      overlapStats: getAreaOverlap(state),
      newCustomerOverlapStats: getNewCustomerOverlap(state),
      recommendedConfiguredItems,
      securityCorrelations,
      chartFormattedValueRealized,
      criticalSecurityCorrelationsCount,
      acceptableCriticalSecurityCorrelationsCount,
      keyGoalsCount,
      configuredItemsCount,
      peakBuffer,
      recommendations: {
        shouldBeInUse: shouldBeInUseRecommendations,
        couldBeInUse: couldBeInUseRecommendations
      }
    };
  };

  // see '../actions/dsaActions'
  const mapDispatchToProps = (dispatch) => {
    return Object.assign({}, bindActionCreators(actionCreators, dispatch), {

      dismissTrainingSnackbar: () => {
        dispatch(actionCreators.dismissTrainingSnackbar());
      },

      beginCloneDSAWorkflow: dsa => {
        dispatch(beginCloneDSAWorkflow(dsa));
      },

      confirmBeginConvertCustomerDSAWorkflow: dsa => {
        dispatch(confirmBeginConvertCustomerDSAWorkflow(dsa));
      },

      beginConvertCustomerDSAWorkflow: dsa => {
        dispatch(beginConvertCustomerDSAWorkflow(dsa));
      },

      fetchOpportunities: (accountId) => {
        dispatch(fetchOpportunities(accountId));
      },

      updateDSA: (dsaId, updates) => {
        dispatch(actionCreators.updateDSA(dsaId, updates));
      },

      generatePPTX: (staticComponents, params) => (
        dispatch(actionCreators.generatePPTX(staticComponents, params))
      ),

      setSplunkLearningLink: (type) => {
        dispatch(setSplunkLearningLink(type));
      }
    });
  };

  return connect(mapStateToProps, mapDispatchToProps)(withRouter(DSAView));
}

export default dsaView;
export {defaultPropTypes};



// WEBPACK FOOTER //
// ./src/containers/dsaView.js